import { getCarsBase } from 'app/api';
import { loggingException } from './sentry';

class MeetgoCenter {
	constructor() {
		this.centerPhoneNumber = '02-778-9583';
		this.centerCode = '153';
	}

	changeCenterPhoneNumber(num) {
		this.centerPhoneNumber = num;
	}

	changeCenterCode(num) {
		this.centerCode = num;
	}

	callCenterPhoneNumber() {
		window.location.href = `tel:${this.centerPhoneNumber}`;
	}

	goCenterPage() {
		if (window.opener) {
			const popupUrl = `${window.location.protocol}//${window.location.host}/meetgo/center/${this.centerCode}`;
			window.open(popupUrl, 'popup_meetgo_center', 'width=1050,height=800,scrollbars=yes');
			return;
		}
		window.location.href = `/meetgo/center/${this.centerCode}`;
	}
}

export default MeetgoCenter;

// 믿고 전용광고(dummyVehicleId) 페이지로 이동하는 함수
export const moveToMeetgoAdvertisementDetailPage = ({ carId, history }) => {
	getCarsBase(carId)
		// 차량 상세 URL로 이동시 필요한 dummyId를 얻기 위한 호출, 더미 id 없을때 원본 id로 이동
		.then((response) => {
			const { data } = response;
			history.push(`/cars/detail/${data?.manage?.dummyVehicleId || carId}`);
		})
		.catch((e) => {
			alert('잠시 후 다시 시도해주세요.');
			loggingException(e);
		});
};
